import { render, staticRenderFns } from "./LinePropertyEditor.vue?vue&type=template&id=5c344656&scoped=true&"
import script from "./LinePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./LinePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c344656",
  null
  
)

export default component.exports